<template>
  <section class="about-go-to-giftee-top">
    <div class="about-go-to-giftee-top__contents">
      <p class="about-go-to-giftee-top__text">
        さっそくギフトを贈ってみませんか？
      </p>
      <button class="about-go-to-giftee-top__button" @click="onClickButton">
        <span class="about-go-to-giftee-top__button__text">{{
          'gifteeトップへ'
        }}</span>
        <ArrowForwardPrimary class="about-go-to-giftee-top__button__icon" />
      </button>
    </div>
  </section>
</template>

<script>
import ArrowForwardPrimary from '../../../atoms/svg_icons/ArrowForwardPrimary'
export default {
  components: { ArrowForwardPrimary },
  methods: {
    onClickButton() {
      location.href = '/'
    }
  }
}
</script>

<style lang="scss" scoped>
.about-go-to-giftee-top {
  background-color: $primary;

  &__contents {
    margin: auto;
    padding: 66px 0;

    @media all and (max-width: $pc-width  - 1) {
      padding: 48px 0;
    }
  }

  &__text {
    font-weight: bold;
    font-size: 1.8rem;
    line-height: 1.6;
    letter-spacing: 0.06em;
    color: $white;

    @media all and (max-width: $pc-width  - 1) {
      font-size: 1.4rem;
    }
  }

  &__button {
    @extend %hover-common;
    margin: 24px auto 0;
    padding: 12px 24px;
    background-color: $white;
    display: flex;
    align-items: center;
    border-radius: 4px;
    cursor: pointer;

    &__text {
      margin-right: 8px;
      color: $primary;
      font-weight: bold;
      font-size: 1.6rem;
      line-height: 2;
      letter-spacing: 0.06em;

      @media all and (max-width: $pc-width  - 1) {
        font-size: 1.4rem;
      }
    }

    &__icon {
      width: 24px;
    }
  }
}
</style>
